import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import { AuthProvider } from "@/context/AuthContext";
import AppLayout from "@/components/AppLayout";
import ProtectedRoute from "@/components/ProtectedRoute";

import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import StudentDashboard from "@/pages/StudentDashboard";
import GenerateQuestions from "@/pages/GenerateQuestions";
import ExamInterface from "@/pages/ExamInterface";
import ExamResult from "@/pages/ExamResult";
import Analytics from "@/pages/Analytics";
import Subscription from "@/pages/Subscription";
import History from "@/pages/History";
import DesktopWorker from "@/pages/DesktopWorker";
import AiSettings from "@/pages/AiSettings";

import AdminOverview from "@/pages/admin/AdminOverview";
import AdminProviders from "@/pages/admin/AdminProviders";
import AdminSettings from "@/pages/admin/AdminSettings";
import AdminWorkers from "@/pages/admin/AdminWorkers";
import AdminBank from "@/pages/admin/AdminBank";

export default function App() {
    return (
        <div className="App">
            <AuthProvider>
                <BrowserRouter>
                    <Routes>
                        <Route element={<AppLayout />}>
                            <Route path="/" element={<Landing />} />
                            <Route path="/login" element={<Login />} />
                            <Route path="/register" element={<Register />} />
                            <Route path="/desktop" element={<DesktopWorker />} />

                            <Route path="/dashboard" element={<ProtectedRoute><StudentDashboard /></ProtectedRoute>} />
                            <Route path="/generate" element={<ProtectedRoute><GenerateQuestions /></ProtectedRoute>} />
                            <Route path="/history" element={<ProtectedRoute><History /></ProtectedRoute>} />
                            <Route path="/ai-settings" element={<ProtectedRoute><AiSettings /></ProtectedRoute>} />
                            <Route path="/exam/:sessionId" element={<ProtectedRoute><ExamInterface /></ProtectedRoute>} />
                            <Route path="/result/:sessionId" element={<ProtectedRoute><ExamResult /></ProtectedRoute>} />
                            <Route path="/analytics/:sessionId" element={<ProtectedRoute><Analytics /></ProtectedRoute>} />
                            <Route path="/subscription" element={<ProtectedRoute><Subscription /></ProtectedRoute>} />

                            <Route path="/admin" element={<ProtectedRoute adminOnly><AdminOverview /></ProtectedRoute>} />
                            <Route path="/admin/providers" element={<ProtectedRoute adminOnly><AdminProviders /></ProtectedRoute>} />
                            <Route path="/admin/settings" element={<ProtectedRoute adminOnly><AdminSettings /></ProtectedRoute>} />
                            <Route path="/admin/workers" element={<ProtectedRoute adminOnly><AdminWorkers /></ProtectedRoute>} />
                            <Route path="/admin/bank" element={<ProtectedRoute adminOnly><AdminBank /></ProtectedRoute>} />
                        </Route>
                    </Routes>
                </BrowserRouter>
            </AuthProvider>
        </div>
    );
}
